// import AppProvider from './providers';
// import AppRouter from './routes';

// export default function App() {
//   return (
//     <AppProvider>
//       <AppRouter />
//     </AppProvider>
//   );
// }
import AppProvider from './providers';
import React from 'react';
import { ConfigProvider, ThemeConfig } from 'antd';
import deDe from 'antd/lib/locale/de_DE';
import enUS from 'antd/lib/locale/en_US';
import GlobalStyle from './styles/GlobalStyle';
import 'typeface-montserrat';
import 'typeface-lato';
import AppRouter from './routes';
import { useLanguage } from './hooks/useLanguage';
import { useAutoNightMode } from '@/hooks/useAutoNightMode';
import { usePWA } from '@/hooks/usePWA';
import { useThemeWatcher } from '@/hooks/useThemeWatcher';
import { useAppSelector } from './hooks/reduxHooks';
import { themeObject } from './styles/themes/themeVariables';

const App: React.FC = () => {
  const { language } = useLanguage();
  const theme = useAppSelector((state) => state.theme.theme);
  const themeConfig: ThemeConfig = {
    token: {
      colorPrimary: themeObject[theme].primary,
      colorSuccess: themeObject[theme].success,
      colorError: themeObject[theme].error,
      colorWarning: themeObject[theme].warning
    }
  };

  usePWA();

  useAutoNightMode();

  useThemeWatcher();

  return (
    <>
      <meta name="theme-color" content={themeObject[theme].primary} />
      <GlobalStyle />
      <ConfigProvider
        theme={themeConfig}
        locale={language === 'en' ? enUS : deDe}
      >
        <AppProvider>
          <AppRouter />
        </AppProvider>
      </ConfigProvider>
    </>
  );
};

export default App;
